export default "__VITE_ASSET__d1c8301c__"